import { GridCellProps } from '@progress/kendo-react-grid';
import { SyntheticEvent, useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import NumberStepper from 'src/components/design-system/NumberStepper';

const ShoppingListQtyCell = (props: GridCellProps) => {
  const field = props.field || '';
  const value = props.dataItem[field] ?? 0;
  const { dataItem, dataIndex, onChange } = props;

  const handleQuantityChange = useCallback(
    (e: SyntheticEvent, newValue: number) => {
      onChange?.({
        dataIndex,
        dataItem,
        field,
        syntheticEvent: e,
        value: newValue,
      });
    },
    [dataIndex, dataItem, field, onChange]
  );

  return (
    <GridCellBase {...props} rowSelectionEnabled={false} className="!p-0 w-[100%]" title={value.toString()}>
      <NumberStepper value={value} onChange={handleQuantityChange} className="w-[100%]" />
    </GridCellBase>
  );
};

export default ShoppingListQtyCell;
